import {Popup} from "devextreme-react/popup";
import {Col, Row} from "react-bootstrap";
import {FormProvider, useForm, useWatch} from "react-hook-form";
import {
    IAccountDto,
    IAccountInfoDto,
} from "../../../dtos/accounting/IAccountDto";
import {NFLookupInput} from "../../Shared/NewForms/NFLookupInput";
import {NFTextInput} from "../../Shared/NewForms/NFTextInput";
import {ChartAccountStatus, accountTypeEnum} from "./StatusTypes";
import {NFLookupAllCatalog} from "../../Shared/NewForms/NFlookupAllCatalog";
import {AppServices} from "../../../config/entities";
import {useEffect, useState} from "react";
import Swal from "sweetalert2";
import {NFCheckBoxInput} from "../../Shared/NewForms/NFCheckBoxInput";
import {useTranslation} from "react-i18next";

interface IProps {
    visible: boolean;
    onCloseModal: () => void;
    groupItems: any;
    selectedItemId: string | undefined;
    setGroupItems: any;
}

const ChartOfAccountsDetail = ({visible, onCloseModal, groupItems, setGroupItems, selectedItemId}: IProps) => {
    const {t} = useTranslation();
    const [generating, setGenerating] = useState(false);
    const [accountData, setAccountData] = useState([]);
    // const [isEditMode, setIsEditMode] = useState(false);

    const {
        register,
        handleSubmit,
        setValue,
        formState: {errors},
        reset,
        formState,
        getValues,
        watch,
        control,
        trigger,
        ...methods
    } = useForm<IAccountInfoDto>();

    // useEffect(() => {
    //     setIsEditMode(selectedItemId !== undefined);
    // }, [selectedItemId]);

    useEffect(() => {
        if (selectedItemId) {
            const selectedItem = groupItems.find(
                (item: IAccountDto) => item.id === selectedItemId
            );
            if (selectedItem) {
                setValue("id", selectedItem.id);
                setValue("name", selectedItem.name);
                setValue("isGroup", selectedItem.isGroup);
                setValue("accountNo", selectedItem.accountNo);
                setValue("accountType", selectedItem.accountType);
                setValue("isQuantity", selectedItem.isQuantity);
                setValue("isAmount", selectedItem.isAmount);
                setValue("isCurrency", selectedItem.isCurrency);
                setValue("typeOfAnalytics1", selectedItem.typeOfAnalytics1);
                setValue("typeOfAnalytics2", selectedItem.typeOfAnalytics2);
                setValue("typeOfAnalytics3", selectedItem.typeOfAnalytics3);
            }
        } else {
            reset();
        }
    }, [selectedItemId, groupItems, setValue, reset]);

    const handleApplyChanges = async (data: IAccountInfoDto) => {
        try {
            if (selectedItemId) {
                const response = await AppServices.Axios.put(`/Accounts`, data);
                const updatedGroupItems = groupItems.map((item: any) =>
                    item.id === selectedItemId ? response.data : item
                );
                setGroupItems(updatedGroupItems);
            } else {
                const response = await AppServices.Axios.post("/Accounts", data);
                setAccountData(response.data);
                const updatedAccountData = [response.data, ...groupItems];
                setGroupItems(updatedAccountData);
            }

            onCloseModal();
        } catch (e) {
            console.log(e);
            await Swal.fire({
                title: "Error",
                text: "An error occurred while generating the documents",
                icon: "error",
            });
        }
    };
    const handleCloseModal = () => {
        onCloseModal();
    };
    return (
        <FormProvider
            getValues={getValues}
            setValue={setValue}
            register={register}
            control={control}
            trigger={trigger}
            reset={reset}
            watch={watch}
            handleSubmit={handleSubmit}
            formState={formState}
            {...methods}
        >
            <Popup
                visible={visible}
                showTitle={true}
                resizeEnabled={true}
                dragEnabled={true}
                hideOnOutsideClick={true}
                dragOutsideBoundary={true}
                onHiding={onCloseModal}
                title={"Edit Account"}
            >
                <form onSubmit={handleSubmit(handleApplyChanges)}>
                    <div className="d-flex justify-content-end mt-3">
                        <button
                            className="btn btn-primary me-2"
                            type="submit"
                        >
                            <i className="bi bi-bookmark" style={{paddingRight: "5px"}}></i>
                            {t("Save")}
                        </button>
                        <button
                            type={"button"}
                            className={"btn btn-light me-2"}
                            onClick={handleCloseModal}
                        >
                            <i className="bi bi-x-circle" style={{paddingRight: "5px"}}></i>
                            Close
                        </button>
                    </div>
                    <Row>
                        <Col sm={6}>
                            <NFTextInput title="Account" fieldName="accountNo"/>
                        </Col>
                        <Col sm={6}>
                            <NFTextInput title="Name" fieldName="name"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFLookupInput
                                title="Account Type"
                                fieldName="accountType"
                                items={ChartAccountStatus}
                            />
                        </Col>
                        <Col sm={6}>
                            <NFCheckBoxInput title="Quantity" fieldName="isQuantity"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFCheckBoxInput title="Amount" fieldName="isAmount"/>
                        </Col>
                        <Col sm={6}>
                            <NFCheckBoxInput title="Currency" fieldName="isCurrency"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFLookupInput
                                title="Type Of Analytics 1"
                                fieldName="typeOfAnalytics1"
                                items={accountTypeEnum}
                            />
                        </Col>
                        <Col sm={6}>
                            <NFLookupInput
                                title="Type Of Analytics 2"
                                fieldName="typeOfAnalytics2"
                                items={accountTypeEnum}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <NFLookupInput
                                title="Type of Analytics 3"
                                fieldName="typeOfAnalytics3"
                                items={accountTypeEnum}
                            />
                        </Col>
                    </Row>
                </form>
            </Popup>
        </FormProvider>
    );
};

export default ChartOfAccountsDetail;
